import { Box, Button, IconButton, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const ModalContent = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column', gap: 40 }),
	width: '100%',
	margin: '48px',
	boxSizing: 'border-box',
});

export const TableTitle = styled(Typography)({
	color: 'rgb(16, 33, 66)',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: '157%',
	letterSpacing: '0.1px',
});

export const AddMethodButton = styled(Button)({
	...flexMixin({ gap: 8 }),
	padding: '10px 16px',
	background: 'unset',
	borderRadius: '8px',

	color: 'rgb(71, 134, 255)',
	fontSize: '16px',
	fontWeight: '700',
	lineHeight: '157%',
	letterSpacing: '0.1px',
	textTransform: 'unset',

	'& svg': {
		fill: 'rgb(71, 134, 255)',
	},

	'&:hover': {
		background: 'rgb(218, 231, 255)',
	},
});

export const MethodInfo = styled(Box)({
	...flexMixin({ justify: 'flex-start', gap: 16 }),
	'& > p': {
		color: 'rgb(16, 33, 66)',
		fontSize: '16px',
		fontWeight: '700',
		lineHeight: '157%',
		letterSpacing: '0.1px',
	},

	'& svg': {
		width: '32px',
		height: '24px',
	},
});

export const MethodRightSide = styled(Box)({
	...flexMixin({ justify: 'flex-end', gap: 16 }),
});

export const MethodExpires = styled(Typography)({
	color: 'rgb(112, 122, 142)',
	fontSize: '14px',
	fontWeight: '400',
	lineHeight: '143%',
	letterSpacing: '0.15px',
});

export const MenuButton = styled(IconButton)({
	'& svg path': {
		fill: 'rgb(71, 134, 255)',
	},
	'&.Mui-disabled': {
		opacity: 0.4,
	},
});

export const LoaderBox = styled(Box)({
	...flexMixin({}),
	width: '100%',
	height: '200px',
});

export const EmptyState = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column' }),
	width: '100%',
	textAlign: 'center',
	marginBottom: '20px',
	maxWidth: '500px',

	'& svg': {
		width: '48px',
		height: '48px',
		'& path': {
			fill: 'rgb(71, 134, 255)',
		},
	},

	'& h3': {
		fontSize: '20px',
		fontWeight: 700,
		lineHeight: '160%',
		letterSpacing: '0.15px',
		color: '#0E1B33',
		margin: '24px 0 8px 0',
	},

	'& p': {
		fontSize: '16px',
		fontWeight: 400,
		lineHeight: '150%',
		letterSpacing: '0.15px',
		color: '#0E1B33',
	},
});

export const DefaultCard = styled(Box)({
	padding: '4px 8px',
	borderRadius: '4px',
	background: 'rgb(231, 238, 255)',
	'& p': {
		color: 'rgb(26, 94, 236)',
		fontSize: '12px',
		fontWeight: '400',
		lineHeight: '166%',
		letterSpacing: '0.4px',
	},
});
